// extracted by mini-css-extract-plugin
export default {"customSelect":"Select_customSelect__fQSWi","inputLabel":"Select_inputLabel__gcezt","list":"Select_list__cctUj","listItem":"Select_listItem__77zkt"};